import axios from 'axios'

// Базовый URL API - для разработки используем localhost, для продакшна - ваш сервер
const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:8000/api'

// Получаем данные инициализации Telegram
const getTelegramInitData = () => {
  return window.Telegram?.WebApp?.initData || ''
}

// Создаем экземпляр axios
const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json'
  }
})

// Добавляем interceptor для включения initData в каждый запрос
api.interceptors.request.use(config => {
  const initData = getTelegramInitData()
  if (initData) {
    config.headers['X-Telegram-Init-Data'] = initData
  }
  return config
})

// API методы

// Продукты
export const getProducts = async () => {
  const response = await api.get('/products')
  return response.data
}

export const getProduct = async (id) => {
  const response = await api.get(`/products/${id}`)
  return response.data
}

export const getProductsByCategory = async (category) => {
  const response = await api.get(`/products/category/${category}`)
  return response.data
}

// Корзина
export const getCart = async (userId) => {
  const response = await api.get(`/cart/${userId}`)
  return response.data
}

export const addToCart = async (userId, item) => {
  const response = await api.post(`/cart/${userId}`, item)
  return response.data
}

export const removeFromCart = async (userId, productId, size = null, color = null) => {
  const response = await api.delete(`/cart/${userId}/${productId}`, {
    params: { size, color }
  })
  return response.data
}

export const clearCart = async (userId) => {
  const response = await api.delete(`/cart/${userId}`)
  return response.data
}

// Заказы
export const createOrder = async (orderData) => {
  const response = await api.post('/orders', orderData)
  return response.data
}

export const getOrders = async (userId) => {
  const response = await api.get(`/orders/${userId}`)
  return response.data
}

export const getOrder = async (orderId) => {
  const response = await api.get(`/orders/detail/${orderId}`)
  return response.data
}

// Платежи
export const createPayment = async (orderId) => {
  const response = await api.post(`/payment/create/${orderId}`)
  return response.data
}

export const checkPaymentStatus = async (orderId) => {
  const response = await api.get(`/payment/status/${orderId}`)
  return response.data
}

// Категории
export const getCategories = async () => {
  const response = await api.get('/categories')
  return response.data
}

export default api











